import { MyrAPIService } from '../../../api/myr/myrAPI';
import { MyrAPIEndpoints } from '../../../api/myr/myrAPIEndpoints.constant';

export class RevokeSessionService {
    static requestSessionRevoke<T>(): Promise<T> {
        return MyrAPIService.sendRequest(MyrAPIEndpoints.LOGOUT_ALL, 'POST');
    }
}
